export const APP_NAMES = Object.freeze({
  STATUS_TRACKER: 'statusTracker',
  SELF_CHECK_IN: 'selfCheckIn',
  CONSUMER_8: 'consumer8'
});

export const MICROSITES_NAMES = Object.freeze([
  APP_NAMES.STATUS_TRACKER,
  APP_NAMES.SELF_CHECK_IN
]);



// WEBPACK FOOTER //
// ./src/constants/appName.js